// @ts-ignore
import { useState } from "react"
import { useNavigate} from "react-router-dom"
import Header from "@/components/layout/Header"
import Footer from "@/components/layout/Footer"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
// import { loginMember, findLoginId, resetPassword, updateMemberInfo } from "@/api/authApi"
import { loginMember, resetPassword, updateMemberInfo } from "@/api/authApi"
import { useAuth } from "@/contexts/AuthContext.tsx"

export default function LoginPage() {
    const navigate = useNavigate()
    const { refreshAuth } = useAuth()
    const [loading, setLoading] = useState(false)

    const [form, setForm] = useState({ loginId: "", password: "" })

    // 모달 상태 관리

    // @ts-ignore
    const [isIdModalOpen, setIsIdModalOpen] = useState(false)
    const [isPwModalOpen, setIsPwModalOpen] = useState(false)
    const [forcePwChangeModal, setForcePwChangeModal] = useState(false) // 💡 강제 변경 모달

    // 폼 상태
    // const [findIdForm, setFindIdForm] = useState({ memberName: "", email: "" })
    const [findPwForm, setFindPwForm] = useState({ loginId: "", email: "" })
    const [issuedTempPw, setIssuedTempPw] = useState("") // 💡 발급된 임시 비밀번호 표시용
    const [forcePwForm, setForcePwForm] = useState({ password: "", passwordConfirm: "" })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    // 💡 1. 로그인 실행 (임시 비밀번호 체크 추가)
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!form.loginId || !form.password) return alert("아이디와 비밀번호를 모두 입력해주세요.")

        try {
            setLoading(true)
            const res = await loginMember({ loginId: form.loginId, password: form.password })

            // 백엔드에서 requirePwdChange 플래그가 Y로 넘어온 경우
            if (res.data?.requirePwdChange === 'Y') {
                setForcePwChangeModal(true)
                return // 여기서 로직을 멈추고 모달을 띄움
            }

            await refreshAuth()
            alert("환영합니다!")
            navigate("/")
            window.location.reload()
        } catch (error: any) {
            const errorMsg = error.response?.data?.message || "아이디 또는 비밀번호가 일치하지 않습니다."
            alert(errorMsg)
        } finally {
            setLoading(false)
        }
    }

    // 아이디 찾기
    // const handleFindId = async (e: React.FormEvent) => {
    //     e.preventDefault()
    //     try {
    //         const maskedId = await findLoginId(findIdForm)
    //         alert(`고객님의 아이디는 [ ${maskedId} ] 입니다.`)
    //         setIsIdModalOpen(false)
    //     } catch (error: any) {
    //         alert(error.response?.data?.message || "일치하는 회원 정보를 찾을 수 없습니다.")
    //     }
    // }

    // 💡 2. 비밀번호 찾기 (alert 제거 및 화면에 표시)
    const handleFindPw = async (e: React.FormEvent) => {
        e.preventDefault()
        try {
            const tempPassword = await resetPassword(findPwForm)
            setIssuedTempPw(tempPassword) // 모달 UI 업데이트
        } catch (error: any) {
            alert(error.response?.data?.message || "일치하는 회원 정보를 찾을 수 없습니다.")
        }
    }

    // 💡 3. 강제 비밀번호 변경 로직
    const handleForcePwSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (forcePwForm.password !== forcePwForm.passwordConfirm) {
            return alert("비밀번호가 일치하지 않습니다.")
        }

        const regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[a-zA-Z\d!@#$%^&*]{8,16}$/
        if (!regex.test(forcePwForm.password)) {
            return alert("영문, 숫자, 특수문자를 포함하여 8~16자로 입력해주세요.")
        }

        try {
            await updateMemberInfo({ password: forcePwForm.password })
            alert("비밀번호가 안전하게 변경되었습니다!\n메인 화면으로 이동합니다.")
            await refreshAuth()
            setForcePwChangeModal(false)
            navigate("/")
            window.location.reload()
        } catch(error) {
            alert("비밀번호 변경에 실패했습니다.")
        }
    }

    return (
      <div className="min-h-screen bg-slate-50 text-slate-900">
          <Header />

          <main className="mx-auto flex max-w-7xl items-center justify-center px-4 py-12 lg:px-6 relative">
              <div className="w-full max-w-md">
                  <Card className="rounded-[28px] border border-slate-200 shadow-sm">
                      <CardContent className="p-8">
                          <div className="text-center">
                              <h1 className="text-3xl font-bold">로그인</h1>
                              <p className="mt-2 text-sm text-slate-500">
                                  MG퀵플라워에 로그인하고 더 편리하게 쇼핑하세요.
                              </p>
                          </div>

                          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
                              <div className="space-y-2">
                                  <Label htmlFor="loginId">아이디</Label>
                                  <Input id="loginId" name="loginId" value={form.loginId} onChange={handleChange} placeholder="아이디를 입력하세요" className="h-12 rounded-xl" />
                              </div>

                              <div className="space-y-2">
                                  <Label htmlFor="loginPassword">비밀번호</Label>
                                  <Input id="loginPassword" name="password" type="password" value={form.password} onChange={handleChange} placeholder="비밀번호를 입력하세요" className="h-12 rounded-xl" />
                              </div>

                              <div className="flex items-center justify-between text-sm text-slate-500">
                                  <label className="flex items-center gap-2">
                                      <input type="checkbox" className="h-4 w-4" />
                                      <span>로그인 상태 유지</span>
                                  </label>

                                  <div className="flex items-center gap-3">
                                      <button type="button" onClick={() => setIsIdModalOpen(true)} className="hover:text-slate-900">아이디 찾기</button>
                                      <button type="button" onClick={() => { setIsPwModalOpen(true); setIssuedTempPw(""); }} className="hover:text-slate-900">비밀번호 찾기</button>
                                  </div>
                              </div>

                              <Button type="submit" disabled={loading} className="h-12 w-full rounded-2xl bg-slate-900 text-sm font-semibold hover:bg-slate-800 text-white">
                                  {loading ? "로그인 중..." : "로그인"}
                              </Button>
                          </form>

                          {/* ... 회원가입 링크 생략 (동일함) ... */}
                      </CardContent>
                  </Card>
              </div>

              {/* 아이디 찾기 모달 (동일함) */}
              {/* ... */}

              {/* 💡 비밀번호 찾기 모달 (결과 화면 추가됨) */}
              {isPwModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
                    <Card className="w-full max-w-sm rounded-[24px] shadow-xl">
                        <CardContent className="p-6">
                            {issuedTempPw ? (
                              <div className="text-center space-y-4">
                                  <h2 className="text-xl font-bold">임시 비밀번호 발급 완료</h2>
                                  <p className="text-sm text-slate-500">아래 비밀번호를 복사하여 로그인해주세요.</p>
                                  <div className="bg-slate-100 p-4 rounded-xl text-xl font-mono font-bold tracking-wider text-indigo-600">
                                      {issuedTempPw}
                                  </div>
                                  <div className="flex gap-2 pt-2">
                                      <Button variant="outline" onClick={() => { setIsPwModalOpen(false); setIssuedTempPw(""); }} className="flex-1 h-11 rounded-xl">닫기</Button>
                                      <Button onClick={() => { navigator.clipboard.writeText(issuedTempPw); alert('복사되었습니다.'); }} className="flex-1 h-11 rounded-xl bg-slate-900 text-white">
                                          복사하기
                                      </Button>
                                  </div>
                              </div>
                            ) : (
                              <>
                                  <h2 className="text-xl font-bold mb-4">비밀번호 찾기</h2>
                                  <form onSubmit={handleFindPw} className="space-y-4">
                                      <div>
                                          <Label>아이디</Label>
                                          <Input value={findPwForm.loginId} onChange={e => setFindPwForm({...findPwForm, loginId: e.target.value})} placeholder="가입하신 아이디" className="mt-1 h-11 rounded-xl" required />
                                      </div>
                                      <div>
                                          <Label>이메일</Label>
                                          <Input type="email" value={findPwForm.email} onChange={e => setFindPwForm({...findPwForm, email: e.target.value})} placeholder="가입하신 이메일" className="mt-1 h-11 rounded-xl" required />
                                      </div>
                                      <div className="flex gap-2 pt-2">
                                          <Button type="button" variant="outline" className="flex-1 h-11 rounded-xl" onClick={() => setIsPwModalOpen(false)}>취소</Button>
                                          <Button type="submit" className="flex-1 h-11 rounded-xl bg-slate-900 text-white">임시 발급</Button>
                                      </div>
                                  </form>
                              </>
                            )}
                        </CardContent>
                    </Card>
                </div>
              )}

              {/* 💡 강제 비밀번호 변경 모달 */}
              {forcePwChangeModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 px-4 backdrop-blur-md">
                    <Card className="w-full max-w-sm rounded-[24px] shadow-2xl border-rose-100">
                        <CardContent className="p-6">
                            <h2 className="text-xl font-bold text-rose-600 mb-2">비밀번호 강제 변경 안내</h2>
                            <p className="text-sm text-slate-600 mb-6 leading-relaxed">
                                현재 임시 비밀번호를 사용 중입니다.<br/>
                                안전한 쇼핑몰 이용을 위해 <strong>새 비밀번호</strong>로 변경해주세요.
                            </p>
                            <form onSubmit={handleForcePwSubmit} className="space-y-4">
                                <div className="space-y-2">
                                    <Label>새 비밀번호</Label>
                                    <Input type="password" value={forcePwForm.password} onChange={e => setForcePwForm({...forcePwForm, password: e.target.value})} placeholder="영문,숫자,특수문자 조합 8~16자" className="h-11 rounded-xl" required />
                                </div>
                                <div className="space-y-2">
                                    <Label>새 비밀번호 확인</Label>
                                    <Input type="password" value={forcePwForm.passwordConfirm} onChange={e => setForcePwForm({...forcePwForm, passwordConfirm: e.target.value})} placeholder="새 비밀번호 다시 입력" className="h-11 rounded-xl" required />
                                </div>
                                <Button type="submit" className="w-full h-12 rounded-xl bg-slate-900 text-white mt-4">
                                    변경 완료하고 시작하기
                                </Button>
                            </form>
                        </CardContent>
                    </Card>
                </div>
              )}
          </main>
          <Footer />
      </div>
    )
}